
import ColorPicker from '../components/color-picker.vue';
import SortPicker from '../components/sort-picker.vue';

export default {
  name: 'schedule',
  components: {
    SortPicker,
    ColorPicker
  },
  created() {

    let t = this;

    if (localStorage['cleaner_table_scale']) {
      t.tableScale = Number(localStorage['cleaner_table_scale']);
    }

    t.$eventBus.$on('selectedCleanerChanged', (items, applyColors) => {
      if (applyColors == false) {
        t.colorDict = {};
      }
      else {
        t.colorDict = {};
        items.forEach(item => {
          t.colorDict[item.id] = item;
        });
      }
    });

    t.$eventBus.$emit('openCleanerPicker');

    t.$eventBus.$emit('trigger-selectedCleanerChanged');

    t.statusDict = listToDict(t.list.status);

    t.month = (new Date()).getMonth() + 1;

    if (localStorage['schedule_date_range']) {
      let arr = localStorage['schedule_date_range'].split(',');
      t.startDate = new Date(arr[0]);
      t.endDate = new Date(arr[1]);
      t.days = getDaysDiff(t.startDate, t.endDate);
    }
    else {
      let d = new Date();
      d.setDate(d.getDate() - 2);
      t.startDate = new Date(d.format("yyyy/MM/dd"));
      t.endDate = new Date(t.startDate.getFullYear(), t.startDate.getMonth(), t.startDate.getDate() + 31);
    }

    t.defaultDate = [new Date(t.startDate.format("yyyy/MM/dd")), new Date(t.endDate.format("yyyy/MM/dd"))];

    axios.get('employee?role=2').then(res => {
      if (res.data.status == 1) {
        t.list.cleaner = res.data.options.items;
        t.cleanerDict = {};

        t.list.cleaner.forEach(cleaner => {
          t.cleanerDict[cleaner.id] = cleaner;
        });

        t.loadData();
      }
    });

    let todayText = t.today.format('MM/dd');

    for (let i = 1; i <= t.days; i++) {
      let d = new Date(t.startDate.format('yyyy/MM/dd'));

      d.setDate(d.getDate() + i - 1);

      let date = d.format('MM/dd');

      t.monthGrid[date] = {
        k: 0,
        s: 0,
        suffix: ['日', '月', '火', '水', '木', '金', '土'][d.getDay()],
        is_today: date == todayText
      };
    }

  },
  destroyed() {
    let t = this;
    t.$eventBus.$emit('closeCleanerPicker');
  },
  mounted() {

  },
  activated() {

    let t = this;

  },
  methods: {

    gridBgColor(gridItem, full) {

      let t = this;

      let colorDict = t.colorDict;

      if (gridItem.checkOutItem && colorDict[gridItem.checkOutItem.cleaner_id]) {
        return colorDict[gridItem.checkOutItem.cleaner_id].bgColor;
      }
      else if (gridItem.cleaner_id && colorDict[gridItem.cleaner_id]) {
        return colorDict[gridItem.cleaner_id].bgColor;
      }
      else if (gridItem.sourceCheckInItem) {
        let cleanerId = t.roomCleanerDict[gridItem.room_id + '-' + gridItem.sourceCheckInItem.checkin_date];
        if (cleanerId && colorDict[cleanerId]) {
          if (full)
            return colorDict[cleanerId].bgColor;
          else
            return blendTransparentColor(colorDict[cleanerId].bgColor);
        }
      }
      return '';

    },
    tapGridItem(item) {

      let t = this;

      t.gridItem = item;
      t.boxName = 'set-cleaner';
      t.showWindow = true;
      t.editCleaner();

    },

    editCleaner() {

      let t = this;

      let gridItem = t.gridItem;

      if (gridItem.checkOutItem) {
        t.selectedStatus = t.statusDict[gridItem.checkOutItem.clean_status];
        t.selectedCleaner = t.cleanerDict[gridItem.checkOutItem.cleaner_id];
      }
      else if (gridItem.is_continuous && gridItem.task_id) {
        t.selectedStatus = t.statusDict[gridItem.clean_status];
        t.selectedCleaner = t.cleanerDict[gridItem.cleaner_id];
      }
    },

    printA3() {
      if (window._printStyleTag) window._printStyleTag.remove();
      let style = "@media print { @page {  size: A3 landscape !important; }}";

      let s = document.createElement("style");
      s.innerHTML = style;
      document.body.appendChild(s);
      window._printStyleTag = s;
      window.print();
    },

    printA4() {
      if (window._printStyleTag) window._printStyleTag.remove();
      let style = "@media print { @page {  size: A4 landscape !important; }}";

      let s = document.createElement("style");
      s.innerHTML = style;
      document.body.appendChild(s);
      window._printStyleTag = s;
      window.print();
    },

    loadData() {

      let t = this;

      t.inited = false;

      t.roomGrid = {};
      t.checkInDict = {};
      t.checkOutDict = {};
      t.extraTaskDict = {};
      t.roomCheckInDict = {};
      t.ksDict = {};
      t.roomDict = {};

      axios.get('room').then(res => {

        if (res.data.status == 1) {

          let arr = res.data.options.items;

          arr.forEach(room => {
            room.invisible = false;
            room.selected = false;
            room.active = false;
            t.roomDict[room.id] = room;
          });

          t.list.room = arr;

          axios.get('group').then(res => {
            if (res.data.status == 1) {
              let arr = res.data.options.items;
              arr.forEach(group => {
                group.editing = false;
                group.selected = false;
                group.expanded = true;
                group.rooms = [];
                let roomIds = group.room_ids.split(',');
                roomIds.forEach(roomId => {
                  if (t.roomDict[roomId]) {
                    t.roomDict[roomId].selected = true;
                    group.rooms.push(t.roomDict[roomId]);
                  }
                });
              });

              t.list.group = arr;

              axios.get('order?_with=tasks&date=' + t.startDate.format('yyyy/MM/dd') + '&endDate=' + t.endDate.format('yyyy/MM/dd')).then(res => {
                if (res.data.status == 1) {

                  let arr = res.data.options.items;

                  arr.forEach(order => {
                    let checkInDate = order.checkin_date.replace(/\d{4}[\/-]/, '').replace('-', '/');
                    if (!t.checkInDict[checkInDate])
                      t.checkInDict[checkInDate] = {};
                    t.checkInDict[checkInDate][order.room_id] = order;

                    if (!t.roomCheckInDict[order.room_id])
                      t.roomCheckInDict[order.room_id] = {};
                    t.roomCheckInDict[order.room_id][checkInDate] = order;

                    if (!t.ksDict[checkInDate])
                      t.ksDict[checkInDate] = { k: 0, s: 0, d: 0 };

                    if (order.k) {
                      t.ksDict[checkInDate].k += Number(order.k);
                      t.ksTotal.k += Number(order.k);
                    }

                    if (order.s) {
                      t.ksDict[checkInDate].s += Number(order.s);
                      t.ksTotal.s += Number(order.s);
                    }

                    if (order.d) {
                      t.ksDict[checkInDate].d += Number(order.d);
                      t.ksTotal.d += Number(order.d);
                    }

                    let checkOutDate = order.checkout_date.replace(/\d{4}[\/-]/, '').replace('-', '/');

                    if (!t.checkOutDict[checkOutDate])
                      t.checkOutDict[checkOutDate] = {};
                    t.checkOutDict[checkOutDate][order.room_id] = order;

                    if (order.tasks) {
                      order.tasks.forEach(task => {
                        if (task.cleaner_id)
                          t.roomCleanerDict[order.room_id + '-' + task.date] = task.cleaner_id;
                        if (task.is_extra == 1) {
                          let cleanDate = task.date.replace(/\d{4}[\/-]/, '').replace('-', '/');
                          if (!t.extraTaskDict[cleanDate])
                            t.extraTaskDict[cleanDate] = {};
                          t.extraTaskDict[cleanDate][order.room_id] = task;
                        }
                      });
                    }

                  });

                  let dateExtras = res.data.options.date_extras;

                  if (dateExtras)
                    dateExtras.forEach(item => {
                      if (!t.dateExtraDict[item.room_id])
                        t.dateExtraDict[item.room_id] = {};
                      t.dateExtraDict[item.room_id][item.date] = item;
                    });

                  t.initRoomGrid();

                }
              });

            }
          });
        }
      });

    },

    onSelectDateRange(dates) {
      let t = this;

      if (dates[0] && dates[1]) {

        t.currentDate = dates[0];

        t.startDate = dates[0];

        t.endDate = dates[1];

        t.defaultDate = [new Date(t.startDate.format("yyyy/MM/dd")), new Date(t.endDate.format("yyyy/MM/dd"))];

        localStorage['schedule_date_range'] = t.startDate.format("yyyy/MM/dd") + ',' + t.endDate.format("yyyy/MM/dd");

        t.days = getDaysDiff(t.startDate, t.endDate);

        let todayText = t.today.format('MM/dd');

        t.monthGrid = {};

        for (let i = 1; i <= t.days; i++) {
          let d = new Date(t.startDate.format('yyyy/MM/dd'));

          d.setDate(d.getDate() + i - 1);

          let date = d.format('MM/dd');

          t.monthGrid[date] = {
            k: 0,
            s: 0,
            suffix: ['日', '月', '火', '水', '木', '金', '土'][d.getDay()],
            is_today: date == todayText
          };
        }

        t.loadData();

        t.showDatePopover = false;

      }
    },

    refreshDateItem(gridItem) {

      let t = this;

      gridItem.bg_color = 'bg-pink';

      let cleanDeadline = (new Date(gridItem.checkout_date + ' 13:00:00')).valueOf();

      let now = (new Date()).valueOf();

      if (gridItem.clean_status == 99) {
        //无清扫员
        gridItem.bg_color = 'bg-pink';
      }
      else if (gridItem.clean_status == 1) {
        gridItem.bg_color = 'bg-pink';
      }
      else if (gridItem.clean_status == 2) {
        //正在清扫
        gridItem.bg_color = 'bg-yellow';
      }
      else if (gridItem.clean_status == 3) {
        //清扫完成
        gridItem.bg_color = 'bg-green';
      }

      let d = new Date(t.today.getFullYear() + '/' + gridItem.date);
      let d2 = new Date(t.today.format('yyyy/MM/dd'));

      d2.setDate(d2.getDate() + 3);

      if (gridItem.clean_status == 99 && d2 > d && d >= new Date(t.today.format('yyyy/MM/dd'))) {
        gridItem.bg_color = 'bg-orange';
      }

      if (gridItem.checkin_date) {
        d = new Date(gridItem.checkin_date);
        d2 = new Date(t.today.getFullYear() + '/' + gridItem.date);

        d = d.format('yyyy/MM/dd');
        d2 = d2.format('yyyy/MM/dd');

        if (d == d2 && gridItem.override_clean_status == 3) {
          gridItem.bg_color = 'bg-green';
        }
      }

      if (gridItem.clean_status != 2 && gridItem.clean_status != 3) {
        if (now > cleanDeadline) {
          gridItem.clean_delayed = true;
          gridItem.bg_color = 'bg-red';
        }
      }

    },

    refreshContinuous(gridItem, grid) {

      let t = this;

      let checkInItem = gridItem.checkInItem;

      if (checkInItem && checkInItem.continuous_days > 1) {

        gridItem.continuous_days = checkInItem.continuous_days;

        let room = t.roomDict[gridItem.room_id];

        let date = (new Date(checkInItem.checkin_date)).format('MM/dd');

        for (let i = 1; i < checkInItem.continuous_days; i++) {

          let d = new Date(date);

          d.setDate(d.getDate() + i);

          let date2 = d.format('MM/dd');

          if (!grid[date2])
            grid[date2] = {};

          let dateItem = grid[date2][room.id];

          if (!dateItem)
            dateItem = grid[date2][room.id] = {
              room_name: room.name,
              room_id: room.id,
              date: date2,
              id: null,
              cleaner_name: '',
              cleaner_id: 0,
              source: '',
              status: 99,
              bg_color: 'bg-grey',
              // checkin_date: '',
              // checkout_date: '',
              // count_audlt: 0,
              // count_child: 0,
              // count_baby: 0,
              // k: 0,
              // s: 0,
              continuous_days: 0,
              is_continuous: false,
              is_last_continuous: false,
              cid: null,
              form_status: 1,
              emergency_status: 0,
              year: d.getFullYear()
            };

          dateItem.sourceItem = checkInItem;
          dateItem.is_continuous = true;
          dateItem.is_last_continuous = i == checkInItem.continuous_days - 1;
          dateItem.bg_color = gridItem.bg_color + '2';
          dateItem.sourceCheckInItem = gridItem.checkInItem;

          if (t.extraTaskDict[date2] && t.extraTaskDict[date2][room.id]) {
            let task = t.extraTaskDict[date2][room.id];
            if (task.cleaner_id) {
              dateItem.task_id = task.id;
              dateItem.cleaner_id = task.cleaner_id;
              dateItem.cleaner_name = t.cleanerDict[task.cleaner_id].name;
              dateItem.clean_status = task.status;
            }
            t.refreshDateItem(dateItem);
          }
        }

      }
    },

    refreshCurrentStats() {

      let t = this;

      t.currentStats = {
        task: 0,
        continuous: 0,
        empty: 0,
        checkin: 0
      };

      let currentDateStr = t.currentDate.format('MM/dd');

      t.list.group.forEach(group => {

        group.rooms.forEach(room => {

          for (const date in t.monthGrid) {

            let gridItem = t.roomGrid[date][room.id];

            if (gridItem) {
              gridItem.isCurrentDate = false;
              gridItem.isA = !!((gridItem.checkOutItem && !!gridItem.checkOutItem.cleaner_id) ||
                (gridItem.checkInItem && gridItem.checkInItem.emergency_status == 2) ||
                (gridItem.checkInItem && gridItem.checkInItem.emergency_status == 3) ||
                gridItem.checkOutItem);
              gridItem.isB = gridItem.is_continuous;
              gridItem.isC = !gridItem.checkInItem && !gridItem.is_continuous;
              gridItem.isD = !!(gridItem.checkInItem);

              if (currentDateStr == date) {

                gridItem.isCurrentDate = true;

                if (gridItem.isA)
                  t.currentStats.task++;

                if (gridItem.isB)
                  t.currentStats.continuous++;

                if (gridItem.isC)
                  t.currentStats.empty++;

                if (gridItem.isD)
                  t.currentStats.checkin++;
              }
            }
          }

        });
      });
    },

    initRoomGrid() {

      let t = this;
      let grid = {};

      function fillGrid() {

        t.list.group.forEach(group => {

          group.rooms.forEach(room => {

            for (let j = -15; j <= t.days + 15; j++) {
              let d = new Date(t.startDate.format('yyyy/MM/dd'));

              d.setDate(d.getDate() + j - 1);

              let date = d.format('MM/dd');

              if (!grid[date])
                grid[date] = {};

              let gridItem = grid[date][room.id];

              if (!gridItem)
                gridItem = grid[date][room.id] = {
                  room_name: room.name,
                  room_id: room.id,
                  date: date,
                  id: null,
                  cleaner_name: '',
                  cleaner_id: 0,
                  task_id: null,
                  // source: '',
                  status: 99,
                  bg_color: 'bg-grey',
                  // checkin_date: '',
                  // checkout_date: '',
                  // count_audlt: 0,
                  // count_child: 0,
                  // count_baby: 0,
                  // k: 0,
                  // s: 0,
                  continuous_days: 0,
                  is_continuous: false,
                  is_last_continuous: false,
                  cid: null,
                  form_status: 1,
                  emergency_status: 0,
                  year: d.getFullYear()
                };


              if (t.checkInDict[date] && t.checkInDict[date][room.id]) {

                let checkInItem = {};

                checkInItem.date = date;

                // checkInItem.bg_color = 'bg-pink';

                mirror(t.checkInDict[date][room.id], checkInItem);

                checkInItem.bell_color = 'fill-white';

                if (checkInItem.form_status == 1)
                  checkInItem.bell_color = 'fill-red';

                if (new Date(t.today.getFullYear() + '/' + date).valueOf() < t.today.valueOf())
                  checkInItem.bell_color = 'fill-outline';

                t.refreshDateItem(checkInItem);

                gridItem.checkInItem = checkInItem;
              }

              if (t.checkOutDict[date] && t.checkOutDict[date][room.id]) {

                let checkOutItem = {};

                checkOutItem.date = date;

                mirror(t.checkOutDict[date][room.id], checkOutItem);

                t.refreshDateItem(checkOutItem);


                gridItem.checkOutItem = checkOutItem;
              }

              if (gridItem.checkInItem) {

                gridItem.checkInItem.room_name = gridItem.room_name;

                gridItem.checkInItem.room_id = gridItem.room_id;

                gridItem.checkInItem.dateInGrid = date;

              }

              if (gridItem.checkInItem) {

                let checkInItem = gridItem.checkInItem;

                gridItem.bg_color = checkInItem.bg_color;

                if (checkInItem.continuous_days > 1) {

                  for (let i = 1; i < checkInItem.continuous_days; i++) {

                    let d = new Date(date);

                    d.setDate(d.getDate() + i);

                    let date2 = d.format('MM/dd');

                    if (!grid[date2])
                      grid[date2] = {};

                    let dateItem = grid[date2][room.id];

                    if (!dateItem)
                      dateItem = grid[date2][room.id] = {
                        room_name: room.name,
                        room_id: room.id,
                        date: date2,
                        id: null,
                        cleaner_name: '',
                        cleaner_id: 0,
                        source: '',
                        status: 99,
                        bg_color: 'bg-grey',
                        // checkin_date: '',
                        // checkout_date: '',
                        // count_audlt: 0,
                        // count_child: 0,
                        // count_baby: 0,
                        // k: 0,
                        // s: 0,
                        continuous_days: 0,
                        is_continuous: false,
                        is_last_continuous: false,
                        cid: null,
                        form_status: 1,
                        emergency_status: 0,
                        year: d.getFullYear()
                      };

                    dateItem.sourceItem = checkInItem;
                    dateItem.is_continuous = true;
                    dateItem.is_last_continuous = i == checkInItem.continuous_days - 1;
                    dateItem.bg_color = gridItem.bg_color + '2';
                    dateItem.continuous_bg_color = gridItem.bg_color + '2';

                    if (t.extraTaskDict[date2] && t.extraTaskDict[date2][room.id]) {
                      let task = t.extraTaskDict[date2][room.id];
                      if (task.cleaner_id) {
                        dateItem.cleaner_id = task.cleaner_id;
                        dateItem.cleaner_name = t.cleanerDict[task.cleaner_id].name;
                      }
                      t.refreshDateItem(dateItem);
                    }
                  }

                }

                t.refreshContinuous(gridItem, grid);

              }

              if (gridItem.checkOutItem) {
                let checkOutItem = gridItem.checkOutItem;
                gridItem.bg_color = checkOutItem.bg_color;
                t.refreshContinuous(gridItem, grid);
              }
            }


          });

        });

        t.list.group.forEach(group => {

          group.rooms.forEach(room => {

            for (let j = -15; j <= t.days + 15; j++) {
              let d = new Date(t.startDate.format('yyyy/MM/dd'));

              d.setDate(d.getDate() + j - 1);

              let date = d.format('MM/dd');

              if (!grid[date])
                grid[date] = {};

              let gridItem = grid[date][room.id];

              if (gridItem.checkOutItem && !gridItem.checkInItem) {

                let minDateVal = 0;
                let minDate = '';
                let dateVal = (new Date(t.today.getFullYear() + '/' + date)).valueOf();

                for (const date2 in t.roomCheckInDict[room.id]) {

                  let date2Val = (new Date(t.today.getFullYear() + '/' + date2)).valueOf();

                  if (date2Val > dateVal) {
                    if (minDateVal == 0) {
                      minDateVal = date2Val;
                      minDate = date2;
                    }
                    else if (date2Val < minDateVal) {
                      minDateVal = date2Val;
                      minDate = date2;
                    }
                  }
                }

                if (minDate) {
                  if (grid[minDate] && grid[minDate][room.id] && grid[minDate][room.id].checkInItem) {
                    gridItem.nextCheckInItem = grid[minDate][room.id].checkInItem;
                    gridItem.nextCheckInGridItem = grid[minDate][room.id];

                    if (gridItem.nextCheckInItem) {
                      gridItem.nextCheckInItem.cleaned_at = date;
                      gridItem.nextCheckInItem.bg_color = gridItem.bg_color;
                      gridItem.nextCheckInGridItem.bg_color = gridItem.bg_color;

                      let checkInItem = gridItem.nextCheckInItem;
                      if (checkInItem.continuous_days > 1) {

                        for (let i = 1; i < checkInItem.continuous_days; i++) {

                          let d = new Date(checkInItem.date);

                          d.setDate(d.getDate() + i);

                          let date2 = d.format('MM/dd');

                          if (!grid[date2])
                            grid[date2] = {};

                          let dateItem = grid[date2][room.id];

                          dateItem.sourceItem = checkInItem;
                          dateItem.is_continuous = true;
                          dateItem.is_last_continuous = i == checkInItem.continuous_days - 1;
                          dateItem.bg_color = gridItem.bg_color + '2';
                          dateItem.continuous_bg_color = gridItem.bg_color + '2';

                          if (t.extraTaskDict[date2] && t.extraTaskDict[date2][room.id]) {
                            let task = t.extraTaskDict[date2][room.id];
                            if (task.cleaner_id) {
                              dateItem.cleaner_id = task.cleaner_id;
                              dateItem.cleaner_name = t.cleanerDict[task.cleaner_id].name;
                            }
                            t.refreshDateItem(dateItem);
                          }
                        }

                      }

                      t.refreshContinuous(gridItem.nextCheckInGridItem, t.roomGrid);
                    }

                    let fullDate = (new Date(t.today.getFullYear() + '/' + gridItem.date)).format('yyyy-MM-dd');

                    if (t.dateExtraDict[room.id] && t.dateExtraDict[room.id][fullDate]) {
                      let dateExtra = t.dateExtraDict[room.id][fullDate];
                      gridItem.dateExtra = dateExtra;
                    }
                  }
                }
              }
            }
          });
        });
      }

      fillGrid();

      t.roomGrid = grid;

      t.refreshInvisible();

      t.refreshCurrentStats();

      t.inited = true;

      // setTimeout(function () {
      //     $('.beautyscroll').scrollLeft((t.today.getDate() - 3) * 120);
      // }, 100);
    },

    refreshInvisible() {
      let t = this;
      let date = t.currentDate.format('MM/dd');
      let roomGrid = t.roomGrid;

      t.list.group.forEach(group => {

        group.rooms.forEach(room => {

          if (t.toggle.all) {
            room.invisible = false;
          }
          else {
            room.invisible = true;

            if ((roomGrid[date][room.id].isA && t.toggle.task) ||
              (roomGrid[date][room.id].isB && t.toggle.continuous) ||
              (roomGrid[date][room.id].isC && t.toggle.empty) ||
              (roomGrid[date][room.id].isD && t.toggle.checkin))
              room.invisible = false;
          }
        });

      });
    },

    scrollToDate() {
      this.$refs.calendar.scrollToDate(defaultDate ? defaultDate[0] : this.currentDate);
    },

    saveTableScale() {
      localStorage['cleaner_table_scale'] = this.tableScale;
    },
  },
  data() {
    return {
      showWindow: false,
      boxName: 'set-cleaner',
      selectedCleaner: null,
      selectedStatus: null,
      showCleanerEditor: false,
      showCleanerPopover: false,
      showStatusPopover: false,
      tableScale: 1,
      mode: 'schedule',
      minDate: new Date('2024/01/01'),
      currentDate: Date.today(),
      today: Date.today(),
      days: 31,
      gridItem: null,
      showDatePopover: false,
      defaultDate: null,
      month: 2,
      list: {
        status: [
          { id: 1, text: '未開始' },
          { id: 2, text: '清掃中' },
          { id: 3, text: '完　了' },
        ],
        room: [],
        group: [],
        cleaner: [],
      },
      dict: {
        group: {},
      },
      toggle: {
        all: true,
        task: false,
        continuous: false,
        empty: false,
        checkin: false
      },
      inited: false,
      monthGrid: {},
      roomGrid: {},
      colorDict: {},
      checkInDict: {},
      checkOutDict: {},
      extraTaskDict: {},
      roomCheckInDict: {},
      roomCleanerDict: {},
      statusDict: {},
      ksDict: {},
      ksTotal: { k: 0, s: 0, d: 0 },
      roomDict: {},
      cleanerDict: {},
      dateExtraDict: {},
      currentStats: {
        task: 0,
        continuous: 0,
        empty: 0,
        checkin: 0
      }
    };
  },
  computed: {
  }
};
